import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import "./main.scss";
import { Typography } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import compose from "recompose/compose";
import randomColor from "randomcolor";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { blue } from "@material-ui/core/colors";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { fetchVisits, fetchPatients } from "./actions/index";

const service_list = [
  {
    Title: "Acupuncture",
    Type: "Treatment",
    Principal: "Annie Zhu",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Massage",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Osteopathy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Herbs",
    Type: "Product",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Products",
    Type: "Product",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Physiotherapy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Chiropractic Therapy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Natural Herb Homeopathy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Reiki",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Naturopathy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
  {
    Title: "Homeopathy",
    Type: "Treatment",
    Principal: "Raymond Wang",
    CostFor30Mins: 65,
    CostFor45Mins: 85,
    CostFor60Mins: 120,
  },
];

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#002BB8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#7200B8",
    },
    info: {
      main: "#3177EA",
    },
  },
});

const styles = (theme) => ({
  root: {
    width: "100%",
    // maxWidth: 500,
    minWidth: 350,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "fixed",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  rootDial: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
  avatar: {
    backgroundColor: blue[500],
  },
});

class Services extends Component {
  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      open: false,
      search: null,
      patients: this.props.patients,
      visits: this.props.visits,
      colors: randomColor({
        count: 100,
        hue: "purple",
        luminosity: "light",
      }),
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  handleSearchChange = (arg) => {
    // // console.log(arg)
    this.setState({ search: arg });
    if (arg) {
      this.props.history.push("/patient/" + arg._id);
    }
  };

  componentDidMount() {
    document.title = "Services | Appleby Wellness";
    this.props.fetchPatients(); //.then(() => {this.patientsPrePro()})
    this.props.fetchVisits(); //.then(() => {this.visitsPrePro()})
  }

  componentWillReceiveProps(nextState) {
    console.log("next state", nextState.visits);
    this.setState({
      patients: nextState.patients,
      visits: nextState.visits,
    });
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOpen = () => {
    this.setState({
      open: true,
    });
    // // console.log(this.state.sheetPat);
    // // console.log(this.props.visits);
    // if (this.state.sheetPat) {
    //     // console.log("hit")
    //     this.patientsPrePro()
    // }
    // if(!this.props.visits){
    //     this.visitsPrePro()
    // }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ThemeProvider theme={theme}>
          <Grid
            container
            direction="row-reverse"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item>
              <Autocomplete
                id="searchAuto"
                size="small"
                options={this.props.patients}
                getOptionLabel={(option) =>
                  option.intake.general.firstName +
                  " " +
                  option.intake.general.lastName
                }
                renderOption={(option) => (
                  <React.Fragment>
                    <div>
                      <Typography variant="body1">
                        {option.intake.general.firstName +
                          " " +
                          option.intake.general.lastName}
                      </Typography>
                      <Typography variant="caption">
                        {option.intake.general.cellPhone}
                      </Typography>
                    </div>
                  </React.Fragment>
                )}
                style={{ width: 250 }}
                renderInput={(params) => (
                  <TextField {...params} label="Search" variant="outlined" />
                )}
                onChange={(event, newValue) =>
                  this.handleSearchChange(newValue)
                }
                value={this.state.search}
              />
            </Grid>
          </Grid>
          <hr
            style={{
              borderTopColor: "#cccccc",
              borderTop: 1,
              marginTop: 40,
              marginBottom: 40,
            }}
          />
          <div style={{ width: "100%" }}>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              p={1}
              m={1}
            >
              <Box p={1} flexGrow={1} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
                  Appleby Wellness
                </Typography>
                <Typography variant="h3">Services</Typography>
              </Box>
              <Box p={1}>
                {/* <Button
                  variant="contained"
                  disableElevation
                  color="primary"
                  endIcon={<AddIcon />}
                  onClick={this.createPractitionerDialogPress}
                >
                  Add Practitioner
                </Button> */}
              </Box>
            </Box>
          </div>
          <hr
            style={{
              borderTopColor: "#cccccc",
              borderTop: 1,
              marginTop: 40,
              // marginBottom: 40,
            }}
          />
          <Box mt={8} mb={4}>
          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" style={{ fontWeight: "bold" }}>
                    Service Name
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Service Type
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Principle Practitioner
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Cost per 30 Mins
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {service_list.map((service, index) => (
                  <TableRow
                    key={index}
                    style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#fafafa" }}
                  >
                    <TableCell align="left">{service.Title}</TableCell>
                    <TableCell align="right">{service.Type}</TableCell>
                    <TableCell align="right">
                      {service.Principal}
                    </TableCell>
                    <TableCell align="right">
                      {service.CostFor30Mins}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        </ThemeProvider>
      </div>
    );
  }
}

// function matchDispatchToProps(dispatch) {
//     return bindActionCreators({ submitLogin: submitLogin, isLoggedIn: isLoggedIn },
//         dispatch);
// }

function mapStateToProps(state) {
  return {
    patients: state.patients,
    visits: state.visits,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    fetchVisits,
    fetchPatients,
  })
)(withRouter(Services));
